import { useSelector } from 'react-redux';
import { useGetCustomerPhotoQuery } from '@/slices/customerSlice';

type PhotoCustomer = {
  _id?: string;
  _business?: string | { _id: string };
  photoUrl?: string | null;
};

export function useCustomerPhoto<T extends PhotoCustomer>(customer?: T | null): T | null | undefined {
  const activeBusiness = useSelector((state: any) => state.auth?._id);
  const _business = typeof customer?._business === 'string'
    ? customer._business
    : customer?._business?._id || activeBusiness;
  const { currentData } = useGetCustomerPhotoQuery(
    { _customer: customer?._id, _business },
    { skip: !customer?._id || !/^[a-f\d]{24}$/i.test(customer._id), refetchOnMountOrArgChange: 60 },
  );

  return customer && currentData
    ? { ...customer, photoUrl: currentData.photoUrl }
    : customer;
}
